import { Product, ProductOpaqueValue } from "@b2bportal/purchase-api";
import { ParentState } from "@checkout/types";
import {
  CartContext,
  CommonParentContext,
  VipSupportContext,
} from "@checkout/index";

type VipSupportPriceQuoteRequest = unknown;

export interface VipSupportProduct extends ProductOpaqueValue {
  type: typeof Product.VipSupport;
  value: VipSupportPriceQuoteRequest;
}

export enum VipSupportState {
  route = "route",
  initialize = "initialize",
  addProduct = "addProduct",
  error = "error",
}

export interface PartialParentContextWithVipSupport
  extends CartContext,
    CommonParentContext {
  [ParentState.vipSupport]: VipSupportContext;
}
